import * as React from 'react';

import { withStyles } from '@material-ui/core/styles';

import classNames from 'classnames';

import GridNoPadding from './GridNoPadding';

type Props = {
  icon?: React.Node,
  iconCentered?: boolean,
  children: React.Node,
  className?: string,
  classes: Object,
  leftItemProps?: Object,
  rightItemProps?: Object
};

const Iconized = ({
  icon,
  iconCentered,
  children,
  className,
  classes,
  leftItemProps,
  rightItemProps,
  ...rest
}: Props) => {
  return (
    <GridNoPadding
      className={classNames(classes.root, className)}
      container
      spacing={0}
      alignItems="flex-end"
      wrap="nowrap"
      {...rest}
    >
      {icon && (
        <GridNoPadding
          className={classNames(classes.gridIcon, { [classes.centered]: iconCentered })}
          item
          {...leftItemProps}
        >
          {icon}
        </GridNoPadding>
      )}
      <GridNoPadding className={classes.gridChildren} item xs {...rightItemProps}>
        {children}
      </GridNoPadding>
    </GridNoPadding>
  );
};

const styles = ({ spacing: { unit: spacing } }) => ({
  root: {},
  centered: { margin: 'auto' },
  gridIcon: { padding: spacing * 0, paddingRight: spacing * 1 },
  gridChildren: { padding: spacing * 0 }
});

export default withStyles(styles)(Iconized);
